import React, { useEffect, useState } from 'react';
import { Grid, MenuItem } from '@mui/material';
import CustomFormLabel from '../forms/custom-elements/CustomFormLabel';
import { getAllEventTheme, getAllEventHeadings, getAllEventName } from '../../firebase/functions';
import CustomSelect from '../forms/custom-elements/CustomSelect';

const Event = ({
  selectedEventThemeCode,
  setSelectedEventThemeCode,
  selectedEventNameCode,
  setSelectedEventNameCode,
  selectedEventHeadingCode,
  setSelectedEventHeadingCode,
  isCompulsory = true,
}) => {
  const [eventHeadings, setEventHeadings] = useState([]);
  const [eventNames, setEventNames] = useState([]);
  const [eventTypes, setEventTypes] = useState([]);

  const getEventTheme = async () => {
    const types = await getAllEventTheme();
    let allEventTypes = types
      ?.map((o) => {
        return { name: o.event_theme_name, value: o.event_theme_id };
      })
      .sort((a, b) => a.value - b.value);
    setEventTypes(allEventTypes);
  };

  const getEventHeading = async (themeId) => {
    const headings = await getAllEventHeadings(themeId);
    let allEventHeadings = headings
      ?.map((o) => {
        return { name: o.event_heading_name, value: o.event_heading_id };
      })
      .sort((a, b) => a.value - b.value);
    if (themeId === 2) {
      allEventHeadings = allEventHeadings.filter((o) => o.value === 6);
      getEventName(6);
      setSelectedEventNameCode(34);
      setSelectedEventHeadingCode(6);
    }
    setEventHeadings(allEventHeadings);
  };

  const getEventName = async (headingId) => {
    const names = await getAllEventName(headingId);
    setEventNames(
      names
        ?.map((o) => {
          return { name: o.event_name, value: o.event_name_id };
        })
        .sort((a, b) => a.value - b.value)
        .filter((o) => o.value !== 8),
    );
  };

  useEffect(() => {
    getEventTheme();
  }, []);

  const handleEventThemeChange = (value) => {
    setSelectedEventThemeCode(value);
    setSelectedEventNameCode(undefined);
    setSelectedEventHeadingCode(undefined);
    getEventHeading(value);
  };

  const handleEventHeadingChange = (value) => {
    setSelectedEventNameCode(undefined);
    setSelectedEventHeadingCode(value);
    getEventName(value);
  };

  const handleEventNameChange = (value) => {
    setSelectedEventNameCode(value);
  };

  return (
    <>
      {eventTypes?.length > 0 && (
        <Grid item xs={12} md={3}>
          <CustomFormLabel>Event Theme Name{isCompulsory && <span>*</span>}</CustomFormLabel>
          <CustomSelect
            value={selectedEventThemeCode || ''}
            onChange={(e) => handleEventThemeChange(e.target.value)}
            id="event_theme_code"
            fullWidth
            name="event_theme_code"
            size="small"
          >
            {eventTypes.map((data) => (
              <MenuItem value={data.value} key={data.value}>
                {data.name}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
      )}
      {eventHeadings?.length > 0 && (
        <Grid item xs={12} md={3}>
          <CustomFormLabel>Event Category Name{isCompulsory && <span>*</span>}</CustomFormLabel>
          <CustomSelect
            value={selectedEventHeadingCode || ''}
            onChange={(e) => handleEventHeadingChange(e.target.value)}
            id="event_heading_code"
            fullWidth
            name="event_heading_code"
            size="small"
          >
            {eventHeadings.map((data) => (
              <MenuItem value={data.value} key={data.value}>
                {data.name}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
      )}
      {eventNames?.length > 0 && (
        <Grid item xs={12} md={3}>
          <CustomFormLabel>Event Type</CustomFormLabel>
          <CustomSelect
            value={selectedEventNameCode || ''}
            onChange={(e) => handleEventNameChange(e.target.value)}
            id="event_name_code"
            fullWidth
            name="event_name_code"
            size="small"
          >
            {eventNames.map((data) => (
              <MenuItem value={data.value} key={data.name}>
                {data.name}
              </MenuItem>
            ))}
          </CustomSelect>
        </Grid>
      )}
    </>
  );
};

export default Event;
